import { render, staticRenderFns } from "./PhotosForm.vue?vue&type=template&id=3d5e0ed2&scoped=true&"
import script from "./PhotosForm.vue?vue&type=script&lang=js&"
export * from "./PhotosForm.vue?vue&type=script&lang=js&"
import style0 from "./PhotosForm.vue?vue&type=style&index=0&id=3d5e0ed2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5e0ed2",
  null
  
)

export default component.exports